import styled from 'styled-components';

import { BG_COLOR, TITLE_FONT_SIZE, TITLE_FONT_WEIGHT } from './constants';

export const MenuRecentItemsTitle = styled.h2`
  font-family: ${Styles.fontFamily.base};
  font-weight: ${TITLE_FONT_WEIGHT};
  margin: 0;
  ${Styles.desktop`
    margin: 0.5rem 0 0;
    text-align: center;
    font-size: ${TITLE_FONT_SIZE};
   `}
`;

export const MenuRecentItemsWrapper = styled.div`
  background-color: ${BG_COLOR};
`;

export const MenuRecentItemsInnerWrapper = styled.div`
  padding: 1rem;
`;
